/**
 * This utility prevents the spacebar from scrolling the page when interacting with form elements
 *
 * The browser's default behavior is to scroll down when pressing the spacebar
 * outside of text inputs. But sometimes this also happens when focusing form elements like
 * radio buttons, checkboxes, dropdowns, etc.
 */

/**
 * Prevents the space key from scrolling the page while allowing the keypress to trigger form element actions
 */
export const initPreventSpacebarScroll = (): void => {
  document.addEventListener("keydown", (e: KeyboardEvent) => {
    // Only prevent space key and only when targeting interactive elements
    if (e.key === " " || e.code === "Space") {
      const target = e.target as HTMLElement;

      // Check if target is a form element or has a role attribute indicating it's interactive
      const isInteractiveElement =
        target.tagName === "SELECT" ||
        target.tagName === "BUTTON" ||
        target.tagName === "A" ||
        target.hasAttribute("role") ||
        target.hasAttribute("tabindex");

      // Prevent scroll but allow the space to perform its action on the element
      if (isInteractiveElement && ["INPUT", "TEXTAREA"].includes(target.tagName)) {
        // Stop page from scrolling but let the event continue to the element
        e.preventDefault();
      }
    }
  });
};
